// extracted by mini-css-extract-plugin
export default {"page":"wHP3Y","inner":"_QfJV","divider":"HSdA4","main":"_LKZy"};